export const TICKET_OUT = "Ticket Out"

export const TICKET_OUT_PAGES = {
    TABLE: "table",
}

// tooltip names
export const BACK = 'Back to Menu';

export const TICKET_OUT_FIELDS = [
  {},
  { id: 'machine', label: 'Machine', align: 'left' },
  { id: 'ticketOut', label: 'Ticket Out', align: 'left' },
  { id: 'time', label: 'Time', align: 'left' },
  {},
];


export const BONUS_FIELDS = [
    {},
    {id: 'name', label: 'Name', align: "left"},
    {id: 'bonusName', label: 'Bonus Name', align: "left"},
    {id: 'bonusAmount', label: 'Bonus Amount', align: "left"},
    {}
]


export const CUSTOMER_BONUS_FIELDS = [
    {id: 'firstName', label: 'First Name', align: "center"},
    {id: 'lastName', label: 'Last Name', align: "center"},
    {id: 'tagId', label: 'Tag Id', align: "center"},

]